// extracted by mini-css-extract-plugin
export default {"controls":"BundleControls_controls__GRX08","playButton":"BundleControls_playButton__kjDPA"};